import type { OrgTreeNode } from '@/entities/organization/model/organizationSchema';

export function flattenOrgTree(nodes: OrgTreeNode[]): OrgTreeNode[] {
  const map = new Map(nodes.map((n) => [n.id, n]));
  const roots = nodes.filter((n) => n.depth === 0);
  const walk = (id: string): OrgTreeNode[] => {
    const n = map.get(id);
    if (!n) return [];
    return [n, ...n.children.flatMap(walk)];
  };
  return roots.flatMap((r) => walk(r.id));
}
